import ModuleConfig from '../../modules/ModuleConfig';

export default {
    ...ModuleConfig.translations,
    'api.errors.E_ACCOUNT_GROUP_ACCOUNT_RELATION_ALREADY_EXISTS': 'A megadott felhasználó már tagja a csoportnak!',
    'api.errors.E_VALIDATION': 'Validálási hiba!',
    'api.errors.E_ACCOUNT_NOT_FOUND': 'Felhasználó nem található!',
    'api.errors.E_FORBIDDEN': 'Hozzáférés megtagadva!',
    'api.errors.UNAUTHENTICATED': 'A kért tartalomhoz jelentkezz be újra!',


    'common.appTitle': 'G\'Roby Admin',
    'common.copyright': 'BIG FISH © 2019',
    'common.ok': 'Rendben',
    'common.cancel': 'Mégsem',
    'common.save': 'Mentés',
    'common.delete': 'Törlés',
    'common.deleteAll': 'Összes törlése',
    'common.upload': 'Feltöltés',
    'common.update': 'Csere',
    'common.select': 'Kiválasztás',
    'common.emptyOption': ' -- Nincs --',
    'common.add': 'Hozzáadás',
    'common.edit': 'Szerkesztés',
    'common.sort': 'Rendezés',
    'common.refresh': 'Frissít',
    'common.close': 'Bezár',
    'common.yes': 'Igen',
    'common.no': 'Nem',
    'common.null': 'N/A',
    'common.loading': 'Töltés...',
    'common.open': 'Megnyitás',
    'common.filter': 'Szűrés',
    'common.print': 'Nyomtatás',
    'common.error': 'Hiba történt!',
    'common.clear': 'Szűrés törlése',
    'common.filterActive': 'Csak aktív',

    'notification.succeed': 'Sikeres mentés',
    'notification.deleteSucceed': 'Sikeres törlés',
    'notification.failed': 'Hiba történt',

    'menu.productCategory': 'Kategóriák',
    'menu.banners': 'Bannerek',
    'menu.shipping': 'Szállítás',
    'menu.users': 'Felhasználók',
    'menu.products': 'Termékek',

    'component.drawer.copyright': 'Copyright',
    'component.dataTable.create': 'Hozzáadás',
    'component.dataTable.search.title': 'Keresés',
    'component.dataTable.search.placeholder': 'Írja be a keresendő szöveget...',
    'component.dataTable.next': 'Következő',
    'component.dataTable.previous': 'Előző',
    'component.dataTable.loading': 'Betöltés folyamatban...',
    'component.dataTable.noData': 'Nincs adat',
    'component.dataTable.page': 'Oldal',
    'component.dataTable.of': '/',
    'component.dataTable.rows': 'Elem / oldal',
    'component.productCategorySelect.emptyOption': ' -- Nincs --',
    'component.ProductAttributeTypeSelect.option.MULTIPLE': 'Többszörös',
    'component.ProductAttributeTypeSelect.option.SIMPLE': 'Egyszeres',
    'component.ProductStatusSelect.option.AVAILABLE': 'Elérhető',
    'component.ProductStatusSelect.option.OUT_OF_STOCK': 'Nincs raktáron',
    'component.ProductStatusSelect.option.PERMANENTLY_ENDED': 'Megszűnt',
    'component.ProductStatusSelect.option.SEASONAL': 'Szezonális',
    'component.ProductStatusSelect.option.UNAVAILABLE': 'Nem elérhető',
    'component.LoginAsUserButton.label': 'Belépés a felhasználó nevében',

    'component.FileSelector.fileExists': 'Az adott file már lézetik',
    'component.FileSelector.successDelete': 'Sikeres törlés',
    'component.FileSelector.successUpload': 'Sikeres feltöltés',
    'component.FileSelector.title': 'Tallózás: /{prefix}',

    'component.InputMarkDown.image': 'Kép csatolása',
    'component.InputMarkDown.attachment': 'Csatolmány',
    'component.InputMarkDown.insert': 'Beillesztés',
    'component.InputMarkDown.tutorial': '<a href="/markdown_tutorial.pdf" target="_blank">Segítség <i class="fa fa-question-circle" /></a>',


    'component.DeleteButton.modalTitle': 'Törlés megerősítése',
    'component.DeleteButton.modalBody': 'Biztosan törlöd a kiválasztott elemet?',

    'component.ProductInput.placeholder': 'Termék ID vagy név...',


    'language.en': 'Angol',
    'language.hu': 'Magyar',


    'page.forgotPassword.title': 'Elfelejtett jelszó',
    'page.forgotPassword.description': 'Itt tudod meg az elfelejtett jelszavad',
    'page.forgotPassword.email': 'Email cím',
    'page.forgotPassword.sendReminder': 'Jelszóemlékeztető küldése',
    'page.forgotPassword.notification.forgotPassword.succeed': 'Jelszóemlékeztető email kiküldve',


    'page.login.title': 'G\'Roby Admin',
    'page.login.email': 'Email cím',
    'page.login.password': 'Jelszó',
    'page.login.login': 'Belépés',
    'page.login.forgotPassword': 'Elfelejtett jelszó',
    'page.login.notification.oath.loginFailed': 'Sikertelen bejelentkezés',
    'page.login.notification.loginSucceed': 'Sikeres bejelentkezés',
    'page.login.notification.loginFailed': 'Sikertelen bejelentkezés',


    'page.pageNotFound.title': '404',
    'page.pageNotFound.subTitle': 'NOT FOUND',
    'page.pageNotFound.message': 'Sajnos a keresett oldal nem található',


    'page.profile.title': 'Profil Adatok',
    'page.profile.language.hu': 'Magyar',
    'page.profile.language.en': 'Angol',
    'page.profile.email.title': 'Email',
    'page.profile.email.placeholder': 'test@email.com',
    'page.profile.name.title': 'Név',
    'page.profile.name.placeholder': 'pl. Béla',
    'page.profile.language.title': 'Nyelv',
    'page.profile.save': 'Mentés',
    'page.profile.notification.update.succeed': 'Sikeres mentés',
    'page.profile.notification.update.failed': 'Sikertelen mentés',
    'page.profile.notification.passwordChange.succeed': 'Jelszóváltoztatás sikeres',
    'page.profile.notification.passwordChange.failed': 'Jelszóváltoztatás sikertelen',
    'page.profile.notification.passwordChange.notSame': 'Az új jelszavak nem egyeznek',
    'page.profile.changePassword.title': 'Jelszó beállítások',
    'page.profile.password.title': 'Jelszó',
    'page.profile.password.placeholder': '*****',
    'page.profile.newPassword.title': 'Új jelszó',
    'page.profile.newPassword.placeholder': '*****',
    'page.profile.newPasswordAgain.title': 'Új jelszó újra',
    'page.profile.newPasswordAgain.placeholder': '*****',
    'page.profile.changePassword': 'Jelszó megváltoztatása',


    'page.resetPassword.title': 'Új jelszó beállítása',
    'page.resetPassword.description': 'Add meg az új jelszavad',
    'page.resetPassword.password': 'Új jelszó...',
    'page.resetPassword.passwordAgain': 'Új jelszó újra...',
    'page.resetPassword.changePassword': 'Jelszó megváltoztatása',
    'page.resetPassword.notification.password.notSame': 'A megadott jelszavak nem egyeznek',
    'page.resetPassword.notification.reset.succeed': 'Sikeres jelszóbeállítás',
    'page.resetPassword.notification.reset.failed': 'Jelszóbeállítás sikertelen',
    'page.resetPassword.succeed': 'Jelszóbeállítás sikeres!',


    'module.dashboard.routeName': 'Főoldal',
    'routeName.profile': 'Profil beállítások',
    'routeName.login': 'Bejelentkezés',
    'routeName.accounts': 'Adminisztrátorok',
    'routeName.addRole': 'Jogosultság hozzáadása',
    'module.undefined.routeName': 'Az oldal nem található',


    'logout': 'Kijelentkezés',

};



// WEBPACK FOOTER //
// ./src/i18n/locales/hu.ts